import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

const state = {
  patient: {},
  patients: []
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
